module.exports = __webpack_public_path__ + "static/img/6_2.03407b72.jpg";